<template>
  <div id="job-detail" v-if="!isLoading">
    <b-breadcrumb>
      <b-breadcrumb-item text="Jobs" to="/jobs"/>
      <b-breadcrumb-item :text="`${ job.labRegistrationReference }`" :active="true"/>
    </b-breadcrumb>
    <b-card header-tag="header" header-class="no-border">
      <template slot="header">
        <h2>
          <font-awesome-icon icon="clipboard" class="icon"/>
          {{ job.labRegistrationReference }}
        </h2>
        <span class="urgent-flag" v-if="job && job.priority.toLowerCase().trim() == 'urgent'">
          <font-awesome-icon icon="flag" fixed-width class="icon"/>Urgent
        </span>
      </template>
      <div class="job-status d-flex align-items-center">
        <div
          v-if="job"
          class="badge badge-lg"
          :class="'badge-'+job.status.toLowerCase().trim().replace(/ /g,'-')"
        >{{ job.status }}</div>
        <div>
          <span class="label">Priority</span>
          <span class="value">{{ job.priority }}</span>
        </div>
        <div>
          <span class="label">Received</span>
          <span class="value">{{ job.receivedDate | moment("D MMM YYYY") }}</span>
        </div>
        <div>
          <span class="label">Due</span>
          <span class="value" v-if="job.dueDate">{{ job.dueDate | moment("D MMM YYYY") }}</span>
          <span class="value" v-if="!job.dueDate">-</span>
        </div>
        <div>
          <span class="label">Finalised</span>
          <span
            class="value"
            v-if="job.finalisedDateTime"
          >{{ job.finalisedDateTime | moment("D MMM YYYY h:mmA") }}</span>
          <span class="value" v-if="!job.finalisedDateTime">-</span>
        </div>
      </div>
      <b-row>
        <b-col class="col-border-right">
          <dl>
            <dt>Client</dt>
            <dd>{{ job.client.name }}</dd>
            <dt>Invoice Client</dt>
            <dd>{{ job.invoiceTo.name }}</dd>
            <dt>Contact</dt>
            <dd>{{ job.client.firstName }} {{ job.client.lastName }}</dd>
          </dl>
        </b-col>
        <b-col class="col-border-right">
          <dl>
            <dt>Client Reference</dt>
            <dd>{{ job.clientRegistrationReference || '-' }}</dd>
            <dt>Purchase Order</dt>
            <dd>{{ job.clientOrderNumber || '-' }}</dd>
            <dt>Sampling Site</dt>
            <dd>{{ job.samplingSite || '-' }}</dd>
          </dl>
        </b-col>
        <b-col>
          <dl>
            <dt>Samples</dt>
            <dd>{{ job.numberOfSamples }}</dd>
          </dl>
        </b-col>
      </b-row>
    </b-card>

    <b-tabs class="mt-4">
      <!-- Samples Tab -->
      <b-tab active>
        <template slot="title">
          <font-awesome-icon icon="vials" class="icon"/>Samples
        </template>
        <SamplesTable :job-id="getJobId" class="mt-4"/>
      </b-tab>

      <!-- Results Tab -->
      <b-tab>
        <template slot="title">
          <font-awesome-icon icon="chart-pie" class="icon"/>Results
        </template>
        <ResultsTable :job-id="getJobId" class="mt-4"/>
      </b-tab>

      <!-- Documents Tab -->
      <b-tab v-if="documents.length > 0">
        <template slot="title">
          <font-awesome-icon icon="file-alt" class="icon"/>Documents
        </template>
        <DocumentCard
          v-for="document in documents"
          :key="document.id"
          :document="document"
          :job-id="jobId"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { EventBus } from "@/services/event-bus.js";

import ResultsTable from "@/components/ResultsTable.vue";
import SamplesTable from "@/components/SamplesTable.vue";
import DocumentCard from "@/components/DocumentCard.vue";

import { getJob } from "@/services/api";

export default {
  name: "JobDetail",
  components: {
    SamplesTable,
    ResultsTable,
    DocumentCard
  },
  data() {
    return {
      isLoading: true,
      jobId: null,
      job: { labRegistrationReference: "" },
      breadcrumbs: [
        {
          text: "Jobs",
          href: "/jobs"
        }
      ],
      documents: [
        /*{
          documentFormat: "PDF",
          documentType: "Certificate of Analysis",
          documentName: "02-022515-A-[R01].pdf"
        },
        {
          documentFormat: "CSV",
          documentType: "Certificate of Analysis",
          documentName: "02-022515-A-[R01].pdf"
        }*/
      ]
    };
  },
  mounted: function() {
    EventBus.$emit("showLoader");
    let self = this;
    return getJob(this.$route.params.id).then(job => {
      self.job = job;
      self.jobId = self.$route.params.id;
      self.documents = job.documents;

      if (job) {
        EventBus.$emit("hideLoader");
        self.isLoading = false;
      }
    });
  },
  methods: {},
  computed: {
    getJobId: function() {
      return this.job.jobId;
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";
.urgent-flag {
  margin-right: 0;
  margin-left: auto;
  font-size: 1.2rem;
  color: $danger;
  .icon {
    margin-right: 5px;
    font-size: 1.2rem;
  }
}
.job-status {
  border-bottom: 1px solid $ui-gray-lighter;
  border-top: 1px solid $ui-gray-lighter;
  padding: 20px 0px;
  margin-bottom: 20px;
  div {
    margin-right: 50px;
    span.label {
      display: block;
      font-size: 0.8rem;
      color: $text-color-light;
      text-transform: uppercase;
      font-weight: $font-weight-semibold;
    }
    span.value {
      font-size: 1.2rem;
      font-weight: $font-weight-semibold;
    }
  }
}
.document {
  transition: all 200ms;
  .download-icon {
    margin-right: 0;
    margin-left: auto;
  }
  .file-icon {
    font-size: 2rem;
  }
  .document-name {
    font-weight: $font-weight-semibold;
    font-size: 1.3rem;
    .document-type {
      display: block;
      font-size: 0.8rem;
      color: $ui-gray;
    }
  }
  &:hover {
    border-color: $brand-primary;
    cursor: pointer;
    .download-icon {
      color: $brand-primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JobDetail.vue